import { DownloadOnAppStore } from '../../shared/components/DownloadOnAppStore';
import { DownloadOnGooglePlay } from '../../shared/components/DownloadOnGooglePlay';
import { OllieFloating } from '../../shared/components/OllieFloating';
import { SpeechBubble } from '../../shared/components/SpeechBubble';
import oliveBranch from '../../shared/assets/img/olive-branch.svg';
import { RatingStars } from '../../shared/components/RatingStars';

export const GoToAppStore = () => {

    return (
        <div className='flex flex-col items-center justify-between h-svh gap-10 safe-pb-4 safe-pt-4 px-8 flex-1 overflow-hidden'>
            <title>Go To App Store</title>
            <div className='flex flex-col gap-1 px-8 items-center justify-center'>
                <h1 className="text-osBlack max-w-[350px] text-[24px] font-bold text-center px-4 leading-snug">Search "ObsessLess" in the App stores</h1>
                <div className="flex items-center justify-center gap-1">
                    <img
                        src={oliveBranch}
                        alt="olive-branch"
                        className="h-[62px]"
                    />
                    <span className="text-osBlack text-[20px] font-semibold mt-1">4.8</span>
                    <RatingStars />
                    <img
                        src={oliveBranch}
                        alt="olive-branch"
                        className="h-[62px] scale-x-[-1]"
                    />
                </div>
            </div>
            <div className='flex flex-col justify-center items-center flex-1 flex-shrink-0'>
                <div className='flex flex-col items-center justify-end overflow-show h-[250px]'>
                    <SpeechBubble text="Awesome! Let's start with your Personal OCD Plan! Just Download the app and start!" />
                    <OllieFloating />
                </div>
            </div>
            <div className="flex flex-col items-center gap-2 flex-shrink-0 w-full">
                <p className="text-osBlack font-semibold text-center">click here 👇</p>
                <DownloadOnAppStore />
                <DownloadOnGooglePlay />
            </div>
        </div>
    );
};